import { classNameGenerator } from "@/utils";

interface CookiePolicyPageProps {}

const CookiePolicyPage: React.FC<CookiePolicyPageProps> = () => {
  return (
    <div id="CookiePolicyPage" className="cookiePolicy">
      <div className="container">
        <div className="c25 doc-content">
          <p className="c34">
            <span className="c22 c32">COOKIE POLICY</span>
          </p>
          <p className="c2">
            <span className="c4 c19">Last Updated: </span>
            <span className="c4 c19">Feb 6, 2024</span>
          </p>
          <p className="c2">
            <span className="c10">INTRODUCTION</span>
          </p>
          <p className="c2">
            <span className="c4">This is the Cookie Policy (&ldquo;</span>
            <span className="c20">Cookie Policy</span>
            <span className="c4">&rdquo;) for the website </span>
            <span className="c4 c36">
              <a className="c30" href="https://www.betheshyft.com">
                https://www.betheshyft.com
              </a>
            </span>
            <span className="c4">, </span>
            <span className="c36 c4">
              <a className="c30" href="https://www.dash.health">
                https://www.dash.health
              </a>
            </span>
            <span className="c4">, </span>
            <span className="c36 c4">
              <a className="c30" href="https://www.mindhouse.com">
                https://www.mindhouse.com
              </a>
            </span>
            <span className="c4">
              &nbsp;and any other service, product, app, or website provided by
              the Company that explicitly specifies the applicability of this
              Cookie Policy (&ldquo;
            </span>
            <span className="c20">Platform</span>
            <span className="c0">
              &rdquo;). This Cookie Policy is applicable to everyone who visits
              and/or uses the Platform.
            </span>
          </p>
          <p className="c2">
            <span className="c4">
              This Cookie Policy describes the collection of cookies on the
              Platform. The Cookie Policy is a part of the Privacy Policy
              available at{" "}
            </span>
            <span className="c27 c4">
              <a
                className="c30"
                href="https://www.betheshyft.com/privacy-policy/"
              >
                https://www.betheshyft.com/privacy-policy/
              </a>
            </span>
            <span className="c4">
              , as updated from time to time. The use of the Platform is subject
              to the Terms of Service available at{" "}
            </span>
            <span className="c4 c27">
              <a
                className="c30"
                href="https://www.betheshyft.com/terms-condition/"
              >
                https://www.betheshyft.com/terms-condition/
              </a>
            </span>
            <span className="c0">
              , as updated from time to time. Capitalized terms used but not
              defined in the Cookie Policy have the same meaning as those
              assigned to it in the Terms of Service.
            </span>
          </p>
          <ol className="c3 lst-kix_list_1-0 start" start="1">
            <li className="c2 c7 li-bullet-0">
              <span className="c10">WHAT ARE COOKIES?</span>
            </li>
          </ol>
          <p className="c2">
            <span className="c4">
              Cookies are small data files that are placed on your computer or
              mobile device when you visit a website. Cookies are widely used by
              website owners in order to make their websites work, or to work
              more efficiently, as well as to provide reporting information.
            </span>
          </p>
          <p className="c2">
            <span className="c4">
              Cookies set by the website owner (in this case, Shyft) are called
              &ldquo;first-party cookies.&rdquo; Cookies set by parties other
              than the website owner are called &ldquo;third-party
              cookies.&rdquo; Third-party cookies enable third-party features or
              functionality to be provided on or through the website (e.g.,
              advertising, interactive content, and analytics). The parties that
              set these third-party cookies can recognize your computer both
              when it visits the website in question and also when it visits
              certain other websites.
            </span>
          </p>
          <ol className="c3 lst-kix_list_1-0" start="2">
            <li className="c2 c7 li-bullet-0">
              <span className="c10">HOW DO WE USE COOKIES?</span>
            </li>
          </ol>
          <p className="c2">
            <span className="c0">
              We use cookies and technologies to provide You the Services and
              improve the services, analyze the use of the Platform, and provide
              You with a personalized experience.
            </span>
          </p>
          <ol className="c3 lst-kix_list_1-0" start="3">
            <li className="c5 c7 li-bullet-0">
              <span className="c10">WHAT CATEGORIES OF COOKIES DO WE USE?</span>
            </li>
          </ol>
          <ol className="c3 lst-kix_list_1-1 start" start="1">
            <li className="c5 c31 li-bullet-1">
              <span className="c10">Based on Duration</span>
              <span className="c0">
                . We use persistent cookies and session cookies. A persistent
                cookie may, for example, help us recognize You as an existing
                user, so it is easier to return to the Platform or interact with
                the Services without signing in again. Session cookies last only
                as long as the session (usually the current visit to a website
                or a browser session).
              </span>
            </li>
            <li className="c5 c31 li-bullet-1">
              <span className="c10">Based on Purpose. </span>
              <span className="c0">We use the following types of cookies:</span>
            </li>
          </ol>
          <ol className="c3 lst-kix_list_2-0 start" start="1">
            <li className="c5 c9 li-bullet-0">
              <span className="c10">Essential or Strictly Necessary</span>
              <span className="c0">
                . We use essential cookies that are necessary for the operation
                of the Platform. Essential cookies are also known as strictly
                necessary cookies. The essential cookies are used for
                authenticating users and preventing fraudulent use of user
                accounts, measuring the stability of the Services,
                identification of users, and keeping users signed in on the
                Platform, and providing features of the Platform.
              </span>
            </li>
            <li className="c5 c9 li-bullet-0">
              <span className="c10">Analytics. </span>
              <span className="c0">
                These cookies help us to improve the way the Platform and
                Services work. These{" "}
              </span>
              <span className="c4">cookies allow</span>
              <span className="c0">
                &nbsp;us to collect statistics and information about how
                customers navigate the Platform so that We can improve the
                experience and performance. Approved third parties may perform
                analytics on Our behalf, but they cannot use the data for their
                own purposes.
              </span>
            </li>
            <li className="c5 c9 li-bullet-0">
              <span className="c10">Advertisement</span>
              <span className="c0">
                . These cookies may be set through Our Platform by Us or Our
                advertising partners and help Us and third parties to inform You
                about products and services that may be of interest to You. If
                You do not allow these cookies, You will experience less
                relevant advertising.
              </span>
            </li>
            <li className="c5 c9 li-bullet-0">
              <span className="c10">Functional. </span>
              <span className="c0">
                These enable Us to personalize Our content for You, remember
                Your preferences, provide useful Platform features, display
                relevant content and improve the performance of Our Services.
              </span>
              <span className="c10">&nbsp;</span>
            </li>
          </ol>
          <ol className="c3 lst-kix_list_1-0" start="4">
            <li className="c2 c7 li-bullet-0">
              <span className="c10">COOKIES PLACED BY SHYFT. </span>
              <span className="c0">We set the following cookies directly:</span>
            </li>
          </ol>
          <a id="t.c3d560cf951b508277583aeb7cc90ee46eac648c"></a>
          <a id="t.0"></a>
          <div className="tableWrapper">
            <table className="c33 c35">
              <tr className="c8">
                <td className="c23" colspan="1" rowspan="1">
                  <p className="c2">
                    <span className="c10">Name</span>
                  </p>
                </td>
                <td className="c17" colspan="1" rowspan="1">
                  <p className="c2">
                    <span className="c10">Description</span>
                  </p>
                </td>
                <td className="c11" colspan="1" rowspan="1">
                  <p className="c2">
                    <span className="c10">Purpose</span>
                  </p>
                </td>
                <td className="c21" colspan="1" rowspan="1">
                  <p className="c2">
                    <span className="c10">Duration</span>
                  </p>
                </td>
              </tr>
              <tr className="c8">
                <td className="c23" colspan="1" rowspan="1">
                  <p className="c2">
                    <span className="c0">__primaryContact</span>
                  </p>
                </td>
                <td className="c17" colspan="1" rowspan="1">
                  <p className="c2">
                    <span className="c0">
                      This helps in providing Services to You.{" "}
                    </span>
                  </p>
                </td>
                <td className="c11" colspan="1" rowspan="1">
                  <p className="c2">
                    <span className="c0">Essential </span>
                  </p>
                </td>
                <td className="c21" colspan="1" rowspan="1">
                  <p className="c2">
                    <span className="c0">30 days </span>
                  </p>
                </td>
              </tr>
              <tr className="c8">
                <td className="c23" colspan="1" rowspan="1">
                  <p className="c2">
                    <span className="c0">__profilePicture</span>
                  </p>
                </td>
                <td className="c17" colspan="1" rowspan="1">
                  <p className="c2">
                    <span className="c0">
                      This helps in loading the images of the Platform faster.
                    </span>
                  </p>
                </td>
                <td className="c11" colspan="1" rowspan="1">
                  <p className="c2">
                    <span className="c0">Essential</span>
                  </p>
                </td>
                <td className="c21" colspan="1" rowspan="1">
                  <p className="c2">
                    <span className="c0">&nbsp;30 days</span>
                  </p>
                </td>
              </tr>
              <tr className="c8">
                <td className="c23" colspan="1" rowspan="1">
                  <p className="c2">
                    <span className="c0">__authAccessToken</span>
                  </p>
                </td>
                <td className="c17" colspan="1" rowspan="1">
                  <p className="c2">
                    <span className="c0">
                      This helps us in authenticating the access.{" "}
                    </span>
                  </p>
                </td>
                <td className="c11" colspan="1" rowspan="1">
                  <p className="c2">
                    <span className="c0">Essential</span>
                  </p>
                </td>
                <td className="c21" colspan="1" rowspan="1">
                  <p className="c2">
                    <span className="c0">&nbsp;30 days</span>
                  </p>
                </td>
              </tr>
              <tr className="c8">
                <td className="c23" colspan="1" rowspan="1">
                  <p className="c2">
                    <span className="c0">__authRefreshToken</span>
                  </p>
                </td>
                <td className="c17" colspan="1" rowspan="1">
                  <p className="c2">
                    <span className="c0">
                      This helps us in authenticating the access.
                    </span>
                  </p>
                </td>
                <td className="c11" colspan="1" rowspan="1">
                  <p className="c2">
                    <span className="c0">Essential </span>
                  </p>
                </td>
                <td className="c21" colspan="1" rowspan="1">
                  <p className="c2">
                    <span className="c0">&nbsp;30 days</span>
                  </p>
                </td>
              </tr>
              <tr className="c8">
                <td className="c23" colspan="1" rowspan="1">
                  <p className="c5">
                    <span className="c0">Uuid</span>
                  </p>
                </td>
                <td className="c17" colspan="1" rowspan="1">
                  <p className="c2">
                    <span className="c0">
                      This helps us in authenticating the access.
                    </span>
                  </p>
                </td>
                <td className="c11" colspan="1" rowspan="1">
                  <p className="c2">
                    <span className="c0">Essential </span>
                  </p>
                </td>
                <td className="c21" colspan="1" rowspan="1">
                  <p className="c2">
                    <span className="c0">&nbsp;30 days</span>
                  </p>
                </td>
              </tr>
              <tr className="c26">
                <td className="c23" colspan="1" rowspan="1">
                  <p className="c5">
                    <span className="c0">Cookie_accepted</span>
                  </p>
                </td>
                <td className="c17" colspan="1" rowspan="1">
                  <p className="c38">
                    <span className="c0">
                      This helps us in identifying whether you have
                      accepted/rejected the cookie policy
                    </span>
                  </p>
                </td>
                <td className="c11" colspan="1" rowspan="1">
                  <p className="c2">
                    <span className="c0">Essential</span>
                  </p>
                </td>
                <td className="c21" colspan="1" rowspan="1">
                  <p className="c2">
                    <span className="c0">30 days</span>
                  </p>
                </td>
              </tr>
            </table>
          </div>
          <p className="c5 c13">
            <span className="c10"></span>
          </p>
          <ol className="c3 lst-kix_list_1-0" start="5">
            <li className="c5 c7 li-bullet-0">
              <span className="c10">THIRD PARTY COOKIES</span>
              <span className="c0">
                . Approved third parties may set cookies during Your
                interactions with the Platform.
              </span>
            </li>
          </ol>
          <ol className="c3 lst-kix_list_1-1 start" start="1">
            <li className="c2 c31 li-bullet-2">
              <span className="c10">Communication Cookies. </span>
              <span className="c0">
                These third-party cookies enable the communication related
                features of the Platform:
              </span>
            </li>
          </ol>
          <a id="t.560b950e8f374b0f3cebee5fc3410e995c0a4e7d"></a>
          <a id="t.1"></a>
          <div className="tableWrapper">
            <table className="c29">
              <tr className="c8">
                <td className="c12" colspan="1" rowspan="1">
                  <p className="c5">
                    <span className="c10">Name</span>
                  </p>
                </td>
                <td className="c6" colspan="1" rowspan="1">
                  <p className="c5">
                    <span className="c10">Third Party&rsquo;s Name</span>
                  </p>
                </td>
                <td className="c15" colspan="1" rowspan="1">
                  <p className="c5">
                    <span className="c10">Purpose</span>
                  </p>
                </td>
                <td className="c18" colspan="1" rowspan="1">
                  <p className="c5">
                    <span className="c10">Duration</span>
                  </p>
                </td>
              </tr>
              <tr className="c8">
                <td className="c12" colspan="1" rowspan="1">
                  <p className="c5">
                    <span className="c0">intercom-device-id-gwfr2dvg</span>
                  </p>
                </td>
                <td className="c6" colspan="1" rowspan="1">
                  <p className="c5">
                    <span className="c0">Intercom</span>
                  </p>
                </td>
                <td className="c15" colspan="1" rowspan="1">
                  <p className="c5">
                    <span className="c0">Customer support chat</span>
                  </p>
                </td>
                <td className="c18" colspan="1" rowspan="1">
                  <p className="c5">
                    <span className="c4 c22">9 Months</span>
                  </p>
                </td>
              </tr>
              <tr className="c26">
                <td className="c12" colspan="1" rowspan="1">
                  <p className="c5">
                    <span className="c0">intercom-id-gwfr2dvg</span>
                  </p>
                </td>
                <td className="c6" colspan="1" rowspan="1">
                  <p className="c5">
                    <span className="c0">Intercom</span>
                  </p>
                </td>
                <td className="c15" colspan="1" rowspan="1">
                  <p className="c5">
                    <span className="c0">Customer support chat</span>
                  </p>
                </td>
                <td className="c18" colspan="1" rowspan="1">
                  <p className="c5">
                    <span className="c0">9 Months</span>
                  </p>
                </td>
              </tr>
              <tr className="c26">
                <td className="c12" colspan="1" rowspan="1">
                  <p className="c5">
                    <span className="c0">intercom-session-gwfr2dvg</span>
                  </p>
                </td>
                <td className="c6" colspan="1" rowspan="1">
                  <p className="c5">
                    <span className="c0">Intercom</span>
                  </p>
                </td>
                <td className="c15" colspan="1" rowspan="1">
                  <p className="c5">
                    <span className="c0">Customer support chat</span>
                  </p>
                </td>
                <td className="c18" colspan="1" rowspan="1">
                  <p className="c5">
                    <span className="c0">7 days (from each log in)</span>
                  </p>
                  <p className="c5 c14">
                    <span className="c0"></span>
                  </p>
                </td>
              </tr>
            </table>
          </div>
          <p className="c2 c14 c37">
            <span className="c10"></span>
          </p>
          <ol className="c3 lst-kix_list_1-1" start="2">
            <li className="c2 c31 li-bullet-1">
              <span className="c10">Advertisement Cookies.</span>
            </li>
          </ol>
          <a id="t.cea2447e7646e42c258ee129eb25ac3e128026bb"></a>
          <a id="t.2"></a>
          <div className="tableWrapper">
            <table className="c29">
              <tr className="c8">
                <td className="c28" colspan="1" rowspan="1">
                  <p className="c5">
                    <span className="c10">Name</span>
                  </p>
                </td>
                <td className="c1" colspan="1" rowspan="1">
                  <p className="c5">
                    <span className="c10">Third Party&rsquo;s Name</span>
                  </p>
                </td>
                <td className="c6" colspan="1" rowspan="1">
                  <p className="c5">
                    <span className="c10">Purpose </span>
                  </p>
                </td>
                <td className="c24" colspan="1" rowspan="1">
                  <p className="c5">
                    <span className="c10">Duration</span>
                  </p>
                </td>
              </tr>
              <tr className="c8">
                <td className="c28" colspan="1" rowspan="1">
                  <p className="c5">
                    <span className="c0">&nbsp;refreshToken</span>
                  </p>
                </td>
                <td className="c1" colspan="1" rowspan="1">
                  <p className="c5">
                    <span className="c0">Tally</span>
                  </p>
                </td>
                <td className="c6" colspan="1" rowspan="1">
                  <p className="c5">
                    <span className="c0">Forms embedded in pages</span>
                  </p>
                </td>
                <td className="c24" colspan="1" rowspan="1">
                  <p className="c5">
                    <span className="c0">1 Year</span>
                  </p>
                </td>
              </tr>
            </table>
          </div>

          <p className="c2 c14 c37">
            <span className="c10"></span>
          </p>
          <ol className="c3 lst-kix_list_1-1" start="3">
            <li className="c2 c31 li-bullet-2">
              <span className="c10">Analytics Cookies: </span>
            </li>
          </ol>
          <a id="t.7a6f24d0f94a02a78d791ab67f6084bd0f66ef4e"></a>
          <a id="t.3"></a>
          <div className="tableWrapper">
            <table className="c29">
              <tr className="c8">
                <td className="c15" colspan="1" rowspan="1">
                  <p className="c5">
                    <span className="c10">Name</span>
                  </p>
                </td>
                <td className="c15" colspan="1" rowspan="1">
                  <p className="c5">
                    <span className="c10">Third Party&rsquo;s Name</span>
                  </p>
                </td>
                <td className="c15" colspan="1" rowspan="1">
                  <p className="c5">
                    <span className="c10">Purpose</span>
                  </p>
                </td>
                <td className="c15" colspan="1" rowspan="1">
                  <p className="c5">
                    <span className="c10">Duration</span>
                  </p>
                </td>
              </tr>
              <tr className="c8">
                <td className="c15" colspan="1" rowspan="1">
                  <p className="c5">
                    <span className="c4">_ga</span>
                  </p>
                </td>
                <td className="c15" colspan="1" rowspan="1">
                  <p className="c5">
                    <span className="c0">Google Analytics</span>
                  </p>
                </td>
                <td className="c15" colspan="1" rowspan="1">
                  <p className="c5">
                    <span className="c4">Analytics</span>
                  </p>
                </td>
                <td className="c15" colspan="1" rowspan="1">
                  <p className="c5">
                    <span className="c4">2 years</span>
                  </p>
                </td>
              </tr>
            </table>
          </div>
          <p className="c14 c39">
            <span className="c16"></span>
          </p>
          <p className="c2 c14">
            <span className="c10"></span>
          </p>
          <ol className="c3 lst-kix_list_1-0" start="6">
            <li className="c5 c7 li-bullet-0">
              <span className="c10">YOUR CHOICES. </span>
              <span className="c0">
                You may modify Your cookie preference by changing browser
                settings. Most web{" "}
              </span>
              <span className="c4">browsers</span>
              <span className="c0">&nbsp;</span>
              <span className="c4">allow</span>
              <span className="c0">
                &nbsp;You to delete cookies that have been placed on Your
                devices, enable or disable cookies entirely, enable or disable
                third-party cookies, or enable or disable cookies for only
                specific websites. c
              </span>
            </li>
          </ol>
          <p className="c5 c33">
            <span className="c0">
              To modify Your cookie preference, kindly follow the instructions
              provided by the web browser. Please note that in the event You
              disable or delete cookies, Your access to parts of the Platform
              and/or Service, or functionality on the Platform and/or Service
              may be limited.
            </span>
          </p>
          <p className="c5 c33">
            <span className="c0">
              In the event that You choose to disable one or more categories of
              cookies, kindly note that We still may use information collected
              prior to Your modification in preference.
            </span>
          </p>
          <ol className="c3 lst-kix_list_1-0" start="7">
            <li className="c5 c7 li-bullet-0">
              <span className="c10">MODIFICATION IN COOKIE POLICY.</span>
              <span className="c0">
                &nbsp;The Cookie Policy may be modified by Us from time to time.
                The modified version of this Cookie Policy will be posted on
                this page, and the &ldquo;Last Updated&rdquo; date at the top
                will indicate the date on which the Cookie Policy was last
                updated.
              </span>
            </li>
          </ol>
          <p className="c5 c13">
            <span className="c0"></span>
          </p>
          <p className="c2 c13">
            <span className="c10"></span>
          </p>
        </div>
      </div>
    </div>
  );
};

export default CookiePolicyPage;
